'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var slugify = function slugify(str) {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-').replace(/(-){2,}/g, '-');
};

exports.default = slugify;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/slugify/slugify.js
// module id = 720
// module chunks = 11